module.exports = __webpack_public_path__ + "img/resources-375.61e9f1b8.jpg";